<template>
  <v-dialog v-model="dialog" max-width="600" @click:outside="cancel">
    <v-card flat>
      <v-container>
        <v-row>
          <v-col cols="auto" class="pl-8 pr-0 my-auto">
            <v-icon large color="secondary">insert_chart</v-icon>
          </v-col>
          <v-col cols="auto" class="pa-0">
            <v-card-title>Benchmark</v-card-title>
            <v-card-subtitle v-if="!loading">
              The benchmark is {{ benchmark }} in this group
            </v-card-subtitle>
          </v-col>
          <v-spacer></v-spacer>
          <v-col cols="auto">
            <v-btn icon @click="cancel">
              <v-icon>close</v-icon>
            </v-btn>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" class="pa-0">
            <v-card-text>
              <v-data-table
                :loading="loading"
                :headers="headers"
                :items="filtered_rankings"
                :footer-props="{
                  'items-per-page-options': [10, 25, 50, 100]
                }"
              >
                <template v-slot:header.rank="{}">
                  <v-icon>security</v-icon>
                </template>
                <template v-slot:item.name="{ item }">
                  <template v-if="item.user">
                    <user-avatar
                      :size="32"
                      :user="item.user"
                      cssClass="mr-2"
                    ></user-avatar>
                    {{ item.user.fullName }}
                  </template>
                  <template v-if="item.manager">
                    <user-avatar
                      :size="32"
                      :user="item.manager"
                      cssClass="mr-2"
                    ></user-avatar>
                    {{ item.manager.fullName }}'s Team
                  </template>
                  <template v-if="item.team">
                    <team-chip :team="item.team"></team-chip>
                  </template>
                  <template v-if="item.coreValue">
                    {{ item.coreValue.name }}
                  </template>
                </template>
                <template v-slot:item.value="{ item }">
                  <template v-if="isPercent">
                    {{ item.percentComplete | no_decimal }}%
                  </template>
                  <template v-else-if="round">
                    {{ item.value | no_decimal }}
                  </template>
                  <template v-else>
                    {{ item.value | one_decimal }}
                  </template>
                </template>
              </v-data-table>
            </v-card-text>
          </v-col>
        </v-row>
        <v-row v-if="excluded_rankings_count > 0">
          <v-col cols="12" class="py-0">
            <v-container class="py-0">
              <v-row class="background rounded-lg secondarytext--text">
                <v-col cols="auto" class="my-auto">
                  <v-img :src="$images.COLLECTION_METHOD_ANONYMOUS"></v-img>
                </v-col>
                <v-col>
                  <div class="primary--text font-weight-bold subtitle-1">
                    Anonymity Limit Exclusion
                  </div>
                  {{ excluded_rankings_count }} {{ exclusion_label }} excluded
                  from this ranking due to the anonymity size limit we have in
                  place that prevents people from easily being identified
                </v-col>
              </v-row>
            </v-container>
          </v-col>
        </v-row>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "CoreCardRankingDialog",
  components: {},
  props: {},
  data: () => ({
    dialog: false,
    valid: false,
    saving: false,
    loading: false,
    filter: {},
    headers: [
      { text: "", value: "rank" },
      { text: "Name", value: "name" },
      { text: "Score", value: "value" }
    ]
  }),
  watch: {},
  computed: {
    isPercent() {
      switch (this.filter.type) {
        case this.$enums.coreCardTypes.ENGAGEMENT:
          return true;
        default:
          return false;
      }
    },
    round() {
      switch (this.filter.type) {
        case this.$enums.coreCardTypes.RECOGNITION:
        case this.$enums.coreCardTypes.ENPS:
          return true;
        default:
          return false;
      }
    },
    benchmark() {
      if (this.rankings.length > 0) {
        let value = this.rankings[0].benchmark;
        if (this.isPercent) {
          return Math.round(value) + "%";
        } else if (this.round) {
          return Math.round(value);
        }
        return value.toFixed(1);
      }
      return 0;
    },
    filtered_rankings() {
      return this.rankings.filter(x => !x.excludeFromRanking);
    },
    excluded_rankings_count() {
      return this.rankings.filter(x => x.excludeFromRanking).length;
    },
    exclusion_label() {
      let label = this.filter.teamId != null ? "department" : "team";
      if (this.excluded_rankings_count > 2) {
        label += "s";
      }
      return label;
    },
    ...mapGetters({ rankings: "corecard/rankings" })
  },
  methods: {
    cancel() {
      this.dialog = false;
      this.$emit("cancel");
    },
    showDialog(filter) {
      this.dialog = true;
      this.filter = filter;

      this.loading = true;
      this.$store
        .dispatch("corecard/getCoreCardRankings", filter)
        .catch(error => {
          this.logError(error);
          this.$root.$alert(
            "Error Occurred",
            "An error occured while loading core card."
          );
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>
